import { useNavigate } from '@tanstack/react-router';

import { apiClient } from '../apiClient';
import { useAuthStore } from '@/stores/authStore';

export function useLogout() {
  const clearAuth = useAuthStore((s) => s.clearAuth);
  const navigate = useNavigate();

  return async () => {
    try {
      await apiClient.post('/api/v1/auth/logout');
    } catch {
      /* ignore */
    }
    clearAuth();
    navigate({ to: '/' });
  };
}
